import { initCardOrderSection } from './components/card-order-section'
import { initFAQ } from 'components/faq'
import initQrPopup from 'components/qr-popup'

const init = (): void => {
  initCardOrderSection()
  initQrPopup()
  initFAQ()
}

window.onload = init
